import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../../constants";
import { FaSpinner } from "react-icons/fa";
import Dynamic_PR_table from "../../../../../components/Dynamic_PR_table";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";
import Select from "react-select";

const DesignationGrouping = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    fetchDesignationGrouping();
    dispatch(updateNavbarHeading("PR Designation Grouping"));
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [modalName, setModalName] = useState();
  const [errors, setErrors] = useState({});
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [designationCategoryOptions, setDesignationCategoryOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [formData, setFormData] = useState({
    MappingID: "",
    DesignationID: [],
  });

  const columns = {
    // ID: { text: "Sr No", align: "center", visible: true },
    MappingName: { text: "Grouping Name", align: "left", visible: true , width: "35px"},
    DesignationName: { text: "Designation Names", align: "start", visible: true ,width: "150px"},
    Description: { text: "Note", align: "start", visible: true,width: "150px" }
  };
  

const handleDesignationChange = (selected) => {
  setFormData((prev) => ({
    ...prev,
    DesignationID: selected
      ? selected.map((item) => Number(item.value))
      : [],
  }));
};

 const handleEdit = async (id) => {
  setIsEditMode(true);
  setModalName("Edit");
  setShowModal(true);

  try {
    const res = await GetServiceCaller(`${API_URL}pr-descategory/${id.GroupID}`);

    setFormData({
      MappingID: res.data.MappingID,
      DesignationID: res.data.DesignationID,
    });

  } catch (error) {
    toast.error("Failed to load data");
  }
};


  const fetchDesignationGrouping = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}pr-descategory`);
      if (response?.status === 200) {
        SetApiStatus(response?.status);
        const listing = response?.data?.categoryListing;
        setData(listing);
        const formValue = response?.data;
        const allNames = data.map((item) => item.Name);
        setSuggestions(allNames);
         setDesignationCategoryOptions(
          formValue?.designationgrouping?.map((el) => ({
            value: el?.value,
            label: el?.text,
          })) || []
        );
       
         setDesignationOptions(
          formValue?.designation?.map((el) => ({
            value: el?.ID,
            label: el?.Name,
          })) || []
        );
         console.log("data",data);

      }
    } catch (error) {
      console.error("Error fetching Domain:", error);
    }
  };

  const handleInputChange = (event) => {
    const { name, type, checked, value } = event.target;
    if (name === "Name") {
      // Filter suggestions that match input
      const matchedSuggestions = suggestions.filter((suggestion) =>
        suggestion.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(matchedSuggestions);
      setShowSuggestions(value.length > 0 && matchedSuggestions.length > 0);
    }

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    });
  };

  const resetFormState = () => {
    setFormData({
      MappingID: "",
      DesignationID: [],
    });
    setIsEditMode(false);
  };

const validateForm = () => {
  const newErrors = {};

  if (!formData.MappingID) {
    newErrors.MappingID = "Category is required";
  }

  if (!formData.DesignationID.length) {
    newErrors.DesignationID = "At least one designation is required";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitted(true);

  if (!validateForm()) {
    setSubmitted(false);
    return;
  }

  const payload = {
    MappingID: formData.MappingID,
    DesignationID: formData.DesignationID,
    IsInActive: formData.IsInActive,
  };

  const url = isEditMode
    ? `${API_URL}pr-descategory/${formData.MappingID}`
    : `${API_URL}pr-descategory`;

  const method = isEditMode ? "put" : "post";

  try {
    const response = await PostServiceCaller(url, payload, method);

    if (response?.status === 200 || response?.status === "success") {
      toast.success(isEditMode ? "Updated successfully" : "Added successfully");

      // ✅ 1️⃣ REFRESH TABLE
      await fetchDesignationGrouping();

      // ✅ 2️⃣ CLOSE MODAL
      handleEditModalClose();

      // ✅ 3️⃣ RESET FLAGS
      setIsEditMode(false);
    } else {
      toast.error(response?.message || "Submission failed");
    }
  } catch (error) {
    toast.error(error?.message || "API Error");
  } finally {
    setSubmitted(false);
  }
};

console.log("Submitting payload:", formData);

const handleCategoryChange = (selected) => {
  setFormData((prev) => ({
    ...prev,
    MappingID: Number(selected?.value) || "",
  }));
};
const selectedCategory =
  designationCategoryOptions.find(
    (x) => Number(x.value) === Number(formData.MappingID)
  ) || null;

 

  const handleEditModalClose = () => {
    setShowModal(false);
    resetFormState();
    setErrors({});
    setShowSuggestions(false);
    setFilteredSuggestions([]);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      const suggestionsElement = document.querySelector(
        ".suggestions-container"
      );
      const inputElement = document.getElementById("Name");
      if (
        showSuggestions &&
        suggestionsElement &&
        !suggestionsElement.contains(event.target) &&
        inputElement !== event.target
      ) {
        setShowSuggestions(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, showSuggestions]);
  const handleAddForm = () => {
    setModalName("Add");

    resetFormState();
    setShowModal(true);
  };
 

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={data}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              //isSorting={true}
              isSrNoRequired={true}
              isAddNewBtnRequired={true}
              isActionRequired={true}
              handleAddNew={handleAddForm}
              handleIcon1={handleEdit}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
              }}
            />
          </div>
          {/* </div> */}
          {/* Bootstrap Modal */}
          {showModal && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1050,
              }}
            >
              <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderBottom: "1px solid #f0f0f0",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px 8px 0 0",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#27568B",
                        margin: "0",
                      }}
                    >{`${modalName} PR Designation Grouping`}</p>
                    <span className="me-2">
                      <i
                        className="bi bi-x-lg"
                        onClick={handleEditModalClose}
                      ></i>
                    </span>
                  </div>
                  <div className="modal-body">
                     <form onSubmit={handleSubmit}>
                                          <div className="row">
                                            <div className="col-md-12">
                                              <div class="mb-3">
                                                <label for="Code" class="form-label">
                                                  Name<span className="required">*</span>
                                                </label>
                                               <Select
                                                    options={designationCategoryOptions}
                                                    placeholder="Select Category"
                                                    value={selectedCategory}
                                                    onChange={handleCategoryChange}
                                                    isDisabled={isEditMode} 
                                                    isClearable
                                                  />
                                              </div>
                                            </div>
                                            <div className="col-12">
                                              <div class="mb-3">
                                                <label for="Code" class="form-label">
                                                  Description
                                                </label>
                                                <Select
                                                  options={designationOptions}
                                                  isMulti
                                                  placeholder="Select Designations"
                                                  value={designationOptions.filter((d) =>
                                                      formData.DesignationID?.includes(d.value)
                                                    )}
                                                  onChange={handleDesignationChange}
                                                  isClearable
                                                />
                                              </div>
                                            </div>
                                          </div>
                    
                                          <div className="text-end">
                                            <button
                                              type="button"
                                              className="cancel-btn me-2"
                                              onClick={handleEditModalClose}
                                            >
                                              Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="custom-btn"
                                                disabled={submitted}
                                              >
                                                {submitted ? (
                                                  <>
                                                    <FaSpinner className="spinner-rotate me-2" />
                                                    Submitting...
                                                  </>
                                                ) : (
                                                  "Submit"
                                                )}
                                              </button>

                                          </div>
                                        </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DesignationGrouping;
